export default __webpack_public_path__ + "static/media/land-1.d357c372.mp4";